export const CLAIM_AI_WORKLOAD = `
  mutation ClaimAIWorkload($workloadId: ID!, $iamRoleArn: String, $resourceArn: String, $guardrailArn: String) {
    claimAIWorkload(
      workloadId: $workloadId
      iamRoleArn: $iamRoleArn
      resourceArn: $resourceArn
      guardrailArn: $guardrailArn
    ) {
      workloadId
      workloadType
      iamRoleArn
      aiComponents
      claimedAt
      claimedBy
    }
  }
`
